import { useEffect } from "react";

const ScrollbarManager = () => {
  useEffect(() => {
    let scrollTimer;
    const body = document.body;

    const handleScroll = () => {
      clearTimeout(scrollTimer);
      body.classList.add("scrolling");
      // for updating the scrollbar when scrolling
      scrollTimer = setTimeout(() => {
        body.classList.remove("scrolling");
      }, 1500); // Extended to 1.5 seconds for better visibility
    }; // again ahh again
    // push pusg, sai changes puhs
    // just for the sake of push 2
    // Initial call to add class on mount
    body.classList.add("scrolling");
    scrollTimer = setTimeout(() => {
      body.classList.remove("scrolling");
    }, 1500);

    // Add scroll event listeners to all scrollable elements
    window.addEventListener("scroll", handleScroll, true);
    document
      .querySelectorAll(
        ".parent-sidebar, .child-sidebar, .main-contenthehe, .table-responsive, .dropdown-menu"
      )
      .forEach((el) =>
        el.addEventListener("scroll", handleScroll, { passive: true })
      );

    // Mouse movement also shows scrollbars briefly
    document.addEventListener("mousemove", handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll, true);
      document
        .querySelectorAll(
          ".parent-sidebar, .child-sidebar, .main-contenthehe, .table-responsive, .dropdown-menu"
        )
        .forEach((el) => el.removeEventListener("scroll", handleScroll));
      document.removeEventListener("mousemove", handleScroll);
      clearTimeout(scrollTimer);
    };
  }, []);

  return null;
};

export default ScrollbarManager;
